<div class="card-stats-number">
    <div class="circle">
        <p class="number">{{ value }}</p>
        <h1 class="title">{{ title }}</h1>
    </div>
</div>
